// auto-generated by Typewriter template _models.tst from PortCall.Models\Schedule\ScheduleDate.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// ScheduleDateData is the class that ScheduleDate serializes to/from
export interface ScheduleDateData {
	
	
    Actual : /* ISO8601 */ string | null;
    Anchor : /* ISO8601 */ string;
    Effective : /* ISO8601 */ string;
    Estimated : /* ISO8601 */ string;
}

// ScheduleDateOptions is the class which may be passed to the ScheduleDate constructor to define optional initial data values
export interface ScheduleDateOptions {
	
	
    Actual? : /* ISO8601 */ string | null;
    Anchor? : /* ISO8601 */ string;
    Estimated? : /* ISO8601 */ string;
}

export class ScheduleDate {
	
	
    public Actual : DataSignal<TZDate | null>;
    public Anchor : DataSignal<TZDate>;
    public Estimated : DataSignal<TZDate>;

    constructor();
    constructor(data : ScheduleDateOptions);
    constructor(data: ScheduleDateOptions | null = null) {
	    
	    
        this.Actual = jsonableObservable(S.value<TZDate | null>(data && data.Actual !== undefined ? data.Actual === null ? null : new TZDate(data.Actual) : null, TZDate.nullableEq));
        this.Anchor = jsonableObservable(S.value<TZDate>(data && data.Anchor !== undefined ? new TZDate(data.Anchor) : new TZDate(0), TZDate.eq));
        this.Estimated = jsonableObservable(S.value<TZDate>(data && data.Estimated !== undefined ? new TZDate(data.Estimated) : new TZDate(0), TZDate.eq));
    }

    static key(obj : ScheduleDate) {
        return ;
    }
    
    static dataKey(obj : ScheduleDateOptions) {
        return ;
    }

    static update(obj : ScheduleDate, data : ScheduleDateOptions) {
        S.freeze(() => {
	        
	        
            if (data.Actual !== undefined) obj.Actual(data.Actual === null ? null : new TZDate(data.Actual));
            if (data.Anchor !== undefined) obj.Anchor(new TZDate(data.Anchor));
            if (data.Estimated !== undefined) obj.Estimated(new TZDate(data.Estimated));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ScheduleDate.ts